/**
 * Dynamic Modal Fetcher
 */
function getCartRequestRoot() {
  return window.Shopify?.routes?.root || '/';
}

function getCartBundledSections() {
  const sections = [];

  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
    bubbles: true,
    detail: { sections }
  }));

  return sections;
}

function openCartDrawerOrRedirect() { 
  const cartDrawer = document.querySelector('cart-drawer'); 
  if (cartDrawer && typeof cartDrawer.show === 'function') { 
    cartDrawer.show(); 
  } else { 
    window.location.href = `${getCartRequestRoot()}cart`; 
  } 
}

async function addItemsToCart(items, options = {}) {
  const root = getCartRequestRoot();
  const sections = getCartBundledSections();
  const body = {
    items,
    sections: sections.join(','),
    sections_url: `${root}cart`
  };

  if (options.attributes) {
    body.attributes = options.attributes;
  }

  const response = await fetch(`${root}cart/add.js`, { 
    method: 'POST', 
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }, 
    body: JSON.stringify(body)
  });
  const responseJson = await response.json();

  if (!response.ok) {
    throw new Error(responseJson.description || 'Add to cart failed');
  }

  const cart = await (await fetch(`${root}cart.js`)).json();
  cart.sections = responseJson.sections || {};
      
  document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
    bubbles: true,
    detail: {
      baseEvent: 'variant:add',
      onSuccessDo: options.onSuccessDo,
      cart
    }
  }));
  document.dispatchEvent(new Event('cart:refresh'));

  return cart;
}

window.addCubeVariantToCart = async function(eventOrButton, variantId, options = {}) {
  const event = eventOrButton instanceof Event ? eventOrButton : null;
  const button = event ? event.currentTarget : eventOrButton;

  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  if (!variantId || button?.disabled) return;

  const label = button?.querySelector('.heading') || button;
  const originalLabel = label?.textContent;
  const atcSource = options.source || button?.dataset?.atcSource || 'global_atc';
  const attributes = {};
  attributes[atcSource] = 'true';

  try {
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    if (label) label.textContent = 'Adding...';

    await addItemsToCart(
      [{ id: parseInt(variantId, 10), quantity: 1, properties: {} }],
      {
        attributes
      }
    );

    openCartDrawerOrRedirect();
  } catch (error) {
    console.error('Add to cart failed', error);
    alert(error.message || 'Error adding to cart');
  } finally {
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
    if (label && originalLabel) label.textContent = originalLabel;
  }
};
